import { render, staticRenderFns } from "./digitalCertificate.vue?vue&type=template&id=aae4e2d2&scoped=true"
import script from "./digitalCertificate.vue?vue&type=script&lang=js"
export * from "./digitalCertificate.vue?vue&type=script&lang=js"
import style0 from "./digitalCertificate.vue?vue&type=style&index=0&id=aae4e2d2&prod&scoped=true&lang=less"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "aae4e2d2",
  null
  
)

export default component.exports